import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import {IonModal, ModalController} from '@ionic/angular';

import { ProductsService } from '@core/services/products/products.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { ActionsModalComponent } from '@shared/modals/actions-modal/actions-modal.component';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class RenameCommand extends BaseProductCommand {
  readonly type = 'rename';
  readonly title = 'Переименовать';
  readonly icon = 'border-color';
  readonly productType: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.CREDIT,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder(
      {
        [ProductTypes.ACCOUNT]: 40, // Счет: Переименовать (4-й в списке "прочее")
        [ProductTypes.SAVE_ACCOUNT]: 40, // Накопительный счет: Переименовать (4-й в списке "прочее")
        [ProductTypes.METAL_ACCOUNT]: 40, // Металлический счет: Переименовать (4-й в списке "прочее")
        [ProductTypes.CARD]: 60, // Карты: Переименовать (6-й в списке "прочее")
        [ProductTypes.CREDIT]: 60, // Кредит: Переименовать (6-й в списке "прочее")
        [ProductTypes.DEPOSIT]: 50 // Вклад: Переименовать (5-й в списке "прочее")
      },
      999
    );
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private modalCtrl: ModalController,
    private productsService: ProductsService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    const productTitle = this.productsService.getProductTitle(context.data, context.data.productType);

    const modal = await this.modalCtrl.create({
      component: ActionsModalComponent,
      handle: false,
      initialBreakpoint: 1,
      cssClass: 'custom',
      componentProps: {
        staticHeight: true,
        autoFocus: true,
        title: this.title,
        label: 'Введите название',
        buttons: [{
          color: 'primary',
          text: 'Применить',
        }],
        inputType: 'text',
        formControl: new FormControl(context.data?.alias || productTitle, [
          Validators.required,
          Validators.maxLength(50)
        ]),
        errorMap: {
          required: 'Введите текст'
        }
      }
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();

    if (data) {
      this.productsService.changeProductAlias(context.data.id, data).subscribe(() => {
        // Уведомляем компонент о необходимости обновиться
        context.onUpdate?.next(null);
      });
    }
  }
}
